import { render } from "./AdminForgotPass.vue?vue&type=template&id=4811f0ea&scoped=true"
import script from "./AdminForgotPass.vue?vue&type=script&lang=js"
export * from "./AdminForgotPass.vue?vue&type=script&lang=js"

import "./AdminForgotPass.vue?vue&type=style&index=0&id=4811f0ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4811f0ea"]])

export default __exports__